import React from 'react';

import { ISiteNameWithId } from '../../siteManagement/serverApi/types/ISiteNameWithId';

export interface SiteRolesPickerContainerEmptyTemplateProps {
    actionHandler: () => void;
    title: string;
    actionTitle: string;
    siteNames: ISiteNameWithId[];
}

export class SiteRolesPickerContainerEmptyTemplate extends React.Component<SiteRolesPickerContainerEmptyTemplateProps, {}> {
    public render() {
        if (!this.props.siteNames || this.props.siteNames.length === 0) {
            return (<span/>);
        } else if (this.props.siteNames) {
            /* eslint-disable jsx-a11y/no-static-element-interactions */
            /* eslint-disable jsx-a11y/click-events-have-key-events */
            /* eslint-disable jsx-a11y/anchor-is-valid */
            return (
                <div className="tb-site-membership-grid-empty">
                    <div className="tb-data-grid-no-matching-results">
                        {this.props.title}
                    </div>
                    <a onClick={this.props.actionHandler}> {this.props.actionTitle} </a>
                </div>
            );
        }
    }
}
